// Selo Premium — o raio amarelo no círculo azul (arte premiumRaio).
//
// Quem ganha: assinante do Turbo (plano pago) E aluno de academia que paga o
// Premium dos alunos (USER.PARCEIRO.TIER = VINCULADO_PREMIUM). Criador nunca é
// assinante — ele tem o selo dele.
//
// seloPremium.webp é o Assets/icons/premiumRaio.webp recortado no círculo e
// reduzido a 256 px (19 KB; o original tem 736 KB), suficiente até 96 px em
// tela 2x. Mesmo formato e mesmas regras do SeloCriador: sempre À DIREITA do
// nome (NomeComSelo), nunca sobre o avatar.

import React from "react";
import seloPremium from "../../Assets/icons/seloPremium.webp";

export default function SeloPremium({ size = 24, glow, className, title = "Premium" }) {
  const s = Number(size) || 24;
  const comGlow = glow ?? s >= 48;
  return (
    <img
      src={seloPremium}
      alt={title}
      width={s}
      height={s}
      draggable={false}
      className={className}
      style={{
        width: s,
        height: s,
        flex: "none",
        display: "inline-block",
        verticalAlign: "middle",
        filter: comGlow ? `drop-shadow(0 0 ${Math.round(s * 0.25)}px rgba(251,189,4,.5))` : "none",
      }}
    />
  );
}
